import store from '../store'

export default (to, from, next ) => {
    if(!store.getters.currentCustomer) next()
    else next('/e-prescription')
}